<template>
    <div class="chat-avartar" :style="styleAvatar">
        <span>{{ getName }}</span>
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'EAvartar',
  props: {
    name: {
      type: String,
      default: 'AV'
    },
    size: {
      type: Number,
      default: 40
    }
  },
  computed: {
    getName: function () {
      let subName = this.name.toUpperCase()
      if (subName.length > 2) {
        subName = subName.substring(0, 2)
      }
      return subName
    },
    styleAvatar: function () {
      return {
        'width': this.size + 'px',
        'height': this.size + 'px',
        'line-height': this.size  + 'px',
        'border-radius': this.size / 2 + 'px'
      }
    }
  }
}
</script>

<style lang="scss">
.chat-avartar {
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 24px;
    background-color: #FFFFFF;
    font-weight: bold;
    color: cadetblue;
    text-align: center;
}
</style>
